import { z } from "zod";
import { ActionSchema } from "../Actions";
import { VisualMediaSchema } from "../Media";
export const LinkItemSchema = z.object({
    title: z.string(),
    accessibilityText: z.string().optional(),
    action: ActionSchema.optional(),
    displayType: z.string().optional(),
    iconName: z.string().optional(),
    iconPosition: z.string().optional(),
    media: VisualMediaSchema.optional(),
    brandColorOverride: z.string().optional(),
});
//# sourceMappingURL=index.js.map